import React, { Suspense, useState } from 'react';
import { Link } from 'react-router-dom';

import { Card, Page } from '@nearst/ui';

import DatePicker from '@components/DatePicker';
import OrganicVisibilityContent from '@components/OrganicVisibilityContent';
import LocationFilter from '../../insights/components/LocationFilter';
import OptionsButton from '../components/OptionsButton';
import ReportFilters from '../components/ReportFilters';
import { useShop } from '@services/ShopProvider';

export const OrganicVisibility = () => {
	const { data: shops } = useShop();

	const [shopIds, setShopIds] = useState(shops.map((shop) => shop.id));
	const [options, setOptions] = useState({
		dataLabels: true,
		referenceLines: false,
		summaryView: false
	});

	return (
		<>
			<Page.Header>
				<Link to="..">
					<Page.BackButton>Reports</Page.BackButton>
				</Link>
				<h1>Organic visibility impact</h1>
				<ReportFilters>
					<DatePicker />
					<LocationFilter shops={shops} selectedShops={shopIds} setSelectedShops={setShopIds} />
					<OptionsButton
						options={[
							{
								id: 'dataLabels',
								label: 'Data labels'
							},
							{
								id: 'referenceLines',
								label: 'Average lines'
							},
							{
								id: 'summaryView',
								label: 'Summary view'
							}
						]}
						values={options}
						setValues={setOptions}
					/>
				</ReportFilters>
			</Page.Header>
			<Page.Section>
				<Card>
					<Suspense fallback={<Card.Loader message="Generating report..." />}>
						<OrganicVisibilityContent options={options} shopIds={shopIds} />
					</Suspense>
				</Card>
			</Page.Section>
		</>
	);
};
